import FinanceInvoice from '../views/finance/FinanceInvoice.vue'
import FinanceQuotes from '../views/finance/FinanceQuotes.vue'
import FinancePayments from '../views/finance/FinancePayments.vue'

import TourSchedule from '../views/reservations/TourSchedule.vue'
import TourItinerary from '../views/reservations/TourItinerary.vue'
import TourCosting from '../views/reservations/TourCosting.vue'
import BookingForm from '../views/reservations/BookingForm.vue'
import TourSummary from '../views/reservations/TourSummary.vue'


import TourPermits from '../views/permits/TourPermits.vue'
import HeldPermits from '../views/permits/HeldPermits.vue'
import BookedPermits from '../views/permits/BookedPermits.vue'

export default [
    // finance: [ "TourScheduleFinance", "FinanceInvoices", "FinanceQuotes", 
    // "FinancePayments", "TourPermitFinance", "OpsPaymentsFinance", ],
    {
        path: '/finance/schedule',
        name: 'TourScheduleFinance',
        component: TourSchedule
    },
    {
        path: '/finance/invoices',
        name: 'FinanceInvoices',
        component: FinanceInvoice
    },
    {
        path: '/finance/costing',
        name: 'FinanceCosting',
        component: TourCosting
    },
    {
        path: '/finance/quotes',
        name: 'FinanceQuotes',
        component: FinanceQuotes
    },
    {
        path: '/finance/payments',
        name: 'FinancePayments',
        component: FinancePayments
    },
    {
        path: '/finance/permits',
        name: 'TourPermitFinance',
        component: TourPermits
    },
];